




import {GET_FillAdminSem} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminSem: null
 
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillAdminSem:
            return {
                AdminSem: action.body
              
              
            }
           

        default:
            return state;
    }
}